<template>
    <div style="height:92%">
      <div class="footerPosition">
        <div class="topLogo">
        <div class="topLeft"><a href="/"><img src="../../../assets/img/logoBlue.png" width="230" /></a></div>
        <div class="topRight">
          <span>Existing account?</span>
          <a href="/reg/login"><b>Sign In</b></a>
        </div>
      </div>
        <router-view></router-view>
        <!-- <div class="pageFooter"><p>2019 Shenzhen Freightshop Technology Co., Ltd. All rights reserved</p></div> -->
        <footerInfo></footerInfo>
      </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import footerInfo from '../public/footerInfo.vue'
    export default {
         components:{footerInfo},

        data (){
            return {
              
            }
        },
        created(){

        },
        methods:{

        }
    }
</script>

<style type="text/css" rel="stylesheet" scoped="scoped">
.topLogo{width:1200px;margin:auto;height:76px;background:#fff;}
.topLogo .topLeft{float:left;margin-top:15px;}
.topLogo .topRight{float:right;line-height:76px;font-size:16px;}
.topLogo .topRight a{margin-left:20px;font-size:16px;color:#666;}
.topLogo .topRight a b{color:#000;}
.pageFooter p{position:absolute;bottom:0;text-align:center;width:100%;border-top:1px solid #f0f0f0;height:60px;line-height:60px;}
.pageFooter p{color:#999;font-size:13px;text-align:center}

</style>



// WEBPACK FOOTER //
// src/components/reception/reg/regCom.vue